// src/views/HomePage.js
import React, { Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';

const OverlappingAvatars = React.lazy(() => import('./OverlappingAvatars'));

const Avatars = () => {
  return (
    <Box>
      <Suspense>
        <OverlappingAvatars />
      </Suspense>
    </Box>
  );
};

export default Avatars;
